import {registerPdfFonts} from "@mytour/pdf-assets";
import type {IPDFStyle, PlatformUserStyle} from "@mytour/shared";
import pdf from "@react-pdf/renderer";

function registerRobotFont() {
  registerPdfFonts("fonts/Roboto");
}

async function toBlob(element: React.ReactElement): Promise<Blob> {
  try {
    const fonts = pdf.Font.getRegisteredFonts();
    if (!Object.keys(fonts).includes("Roboto")) {
      registerRobotFont();
    }
    const blob = await pdf.pdf(element).toBlob();
    return blob;
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  }
}

function getStyle(platformUserStyle: PlatformUserStyle): IPDFStyle {
  const {color, color2, logoContentType} = platformUserStyle;

  const style: IPDFStyle = {
    color,
    color2,
    logoContentType,
    logoHorizontalThumbnail: toBase64String(platformUserStyle.logoHorizontalThumbnail),
    logoSquareThumbnail: toBase64String(platformUserStyle.logoSquareThumbnail),
  };
  return style;
}

function toBase64String(value: unknown): string | undefined {
  if (!value) {
    return undefined;
  }
  if (typeof value === "string") {
    return value;
  }
  if (
    typeof value === "object" &&
    value !== null &&
    "data" in value &&
    Array.isArray((value as {data: unknown}).data)
  ) {
    return Buffer.from((value as {data: number[]}).data).toString("utf8");
  }
  return undefined;
}

export const pdfService = {
  toBlob,
  getStyle,
  registerFonts: registerRobotFont,
};
